import { MARKER_DIAMETER, markerPackStep } from "../../marker/MarkerMetrics/metrics";
import { clampTimelineZoom } from "../WorldMetrics/metrics";

const CAMERA_PACK_MARGIN_X = MARKER_DIAMETER * 7.2;

export function timelineCameraZoom(
  stageW: number,
  characterCount: number,
): number {
  const packWidth = Math.max(
    markerPackStep(),
    characterCount * markerPackStep(),
  );
  const zoomX = stageW / (packWidth + CAMERA_PACK_MARGIN_X);
  return clampTimelineZoom(zoomX);
}
